import dayjs, { Dayjs } from "utils/dayjs"

import { Guid } from "@/types"
import { toDateTimeWithoutTimezone } from "utils/utils"

export interface IGetShippingOrderCartSegmentDto {
    id: Guid
    departureLocationId: Guid
    departureDate: string
    arrivalLocationId: Guid
    arrivalDate: string
    note?: string | null
}

export interface IUpdateShippingOrderCartSegmentDto {
    id: Guid
    sequence?: number | null
    departureLocationId?: Guid
    departureDate?: string
    arrivalLocationId?: Guid
    arrivalDate?: string
    note?: string | null
}

export interface IUpdateShippingOrderCartSegment extends Omit<IUpdateShippingOrderCartSegmentDto, "departureDate" | "arrivalDate"> {
    departureDate?: Dayjs
    arrivalDate?: Dayjs
}

export default class ShippingOrderCartSegment {
    id: Guid
    departureLocationId: Guid
    departureDate: Dayjs
    arrivalLocationId: Guid
    arrivalDate: Dayjs
    note?: string
    sequence: number

    constructor(dto: IGetShippingOrderCartSegmentDto, sequence: number) {
        this.id = dto.id
        this.departureLocationId = dto.departureLocationId
        this.departureDate = dayjs.utc(dto.departureDate)
        this.arrivalLocationId = dto.arrivalLocationId
        this.arrivalDate = dayjs.utc(dto.arrivalDate)
        this.note = dto.note || undefined
        this.sequence = sequence
    }

    static toUpdateDto(data: IUpdateShippingOrderCartSegment): IUpdateShippingOrderCartSegmentDto {
        return {
            ...data,
            departureDate: data.departureDate ? toDateTimeWithoutTimezone(data.departureDate) : undefined,
            arrivalDate: data.arrivalDate ? toDateTimeWithoutTimezone(data.arrivalDate) : undefined,
        }
    }
}
